
import { Stack, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ErrorModal, RootContainer } from "./SSORedirectError.styles";
import {
  ButtonText, Spinner
} from "../../components";
import { AUTH_MODE } from "../../consts";
import { useAuthStore, buildSSOUrlWithFromUrl } from "../../stores";
import { getEnvironmentVariables } from "../../utils/general";

export function SSORedirectErrorPage() {
  const { t } = useTranslation();
  const setSpinnerLoginVisible = useAuthStore(state => state.setSpinnerLoginVisible);
  const theme = useTheme();
  const [isLoadingInternal, setIsLoadingInternal] = useState(false);
  const ssoEndpoint = useAuthStore(state => state.ssoEndpoint);
  const authSSOIsAllowed = useAuthStore(state =>
    state.allowedAuthentications.includes(AUTH_MODE.SSO)
  );
  setSpinnerLoginVisible(false);

  const autoRedirectSsoLogin = ()=>{
    if (!ssoEndpoint) {
      setIsLoadingInternal(false);
      return;
    }

    const ssoUrl = buildSSOUrlWithFromUrl(ssoEndpoint);
    if (getLoginType() === "sso" && authSSOIsAllowed) {
      window.location.replace(ssoUrl);
      setTimeout(() => {
        setIsLoadingInternal(false);
      },1000);
    }else{
      setIsLoadingInternal(false);
    }
  };

  const getLoginType = () => {
    const { loginMode } = getEnvironmentVariables();
    const urlParams = new URLSearchParams(window.location.search);
    let loginType = loginMode?.toLowerCase();
    const urlLoginType = urlParams.get("loginType");
    loginType = (urlLoginType === "sso" || urlLoginType === "manual") ? urlLoginType : (loginType || "");

    const identityProvider = urlParams.get("identity_provider");
    // se presente identity_provider allora loginType è sso
    if (identityProvider) {
      loginType = "sso";
    }

    return loginType;
  };

  return (
    <RootContainer>
      { isLoadingInternal ? (
        <Spinner />
      ) : (
        <ErrorModal theme={ theme }>
          <Stack
            alignItems="center"
            gap={ 4 }
            sx={ { "&:focus-visible": {
              outline: "none"
            } } }
          >
            <Stack
              alignItems="center"
              gap={ 1 }
            >
              <Typography
                aria-labelledby="modal-modal-title"
                color={ theme.customColors.textWidget }
                fontSize="2.2rem"
                fontWeight={ 900 }
              >
                { t("error_message") }
              </Typography>
              <Typography
                aria-describedby="modal-modal-description"
                color={ theme.customColors.textWidget }
                fontSize="1.15rem"
              >
                { t("session_critical_error") }
              </Typography>
            </Stack>
            <ButtonText
              onClick={ autoRedirectSsoLogin }
              aria-labelledby="modal-modal-continue"
              sx={ {
                ":hover": { backgroundColor: alpha(theme.customColors.backgroundPrimaryCta, 0.9) }
              } }
            >
              { t("retry") }
            </ButtonText>
          </Stack>
        </ErrorModal>
      ) }
    </RootContainer>
  );
}
